import React, { FC } from 'react';

type QueueTicketClookProps = { color?: string };

export const QueueTicketClook: FC<QueueTicketClookProps> = ({ color }) => {
  const fillColor = color ?? 'white';
  return (
    <>
      <svg
        width="32"
        height="40"
        viewBox="0 0 64 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="80" rx="32" fill={fillColor} fillOpacity="0.2" />
        <path
          d="M32 25C40.2845 25 47 31.7155 47 40C47 48.2845 40.2845 55 32 55C23.7155 55 17 48.2845 17 40C17 31.7155 23.7155 25 32 25ZM32 31C31.6022 31 31.2206 31.158 30.9393 31.4393C30.658 31.7206 30.5 32.1022 30.5 32.5V40C30.5001 40.3978 30.6582 40.7793 30.9395 41.0605L35.4395 45.5605C35.7224 45.8337 36.1013 45.9849 36.4946 45.9815C36.8879 45.9781 37.2641 45.8203 37.5422 45.5422C37.8203 45.2641 37.9781 44.8879 37.9815 44.4946C37.9849 44.1013 37.8337 43.7224 37.5605 43.4395L33.5 39.379V32.5C33.5 32.1022 33.342 31.7206 33.0607 31.4393C32.7794 31.158 32.3978 31 32 31Z"
          fill={fillColor}
        />
      </svg>
    </>
  );
};
